(function () {
  "use strict";
  if (window.SAEProductLayout) { window.SAEProductLayout.initialize(); return; }
  var source = document.currentScript;
  function initialize() {
    var grid = document.querySelector(".columns-3"), media = grid && grid.querySelector(".column-3");
    var right = grid && grid.querySelector(".column-4");
    var description = grid && grid.querySelector(".product-description-container");
    var navigation = document.getElementById("shopify-section-product-navigation");
    if (source && source.dataset.desktopLayout === "true" && grid && media && right && description && !grid.dataset.saeDesktopLayout) {
      var left = document.createElement("div"); left.className = "sae-product-info-left";
      if (navigation && description.contains(navigation)) right.appendChild(navigation);
      left.appendChild(description); grid.insertBefore(left, media);
      grid.dataset.saeDesktopLayout = "true";
    }
    document.querySelectorAll('[data-node-type="commerce-add-to-cart-form"]').forEach(function (form) {
      if (form.dataset.saeStockBound) return;
      var json = form.querySelector('[data-type="product-variations-data"]');
      if (!json) return;
      var variants; try { variants = JSON.parse(json.textContent); } catch (_) { return; }
      var label = form.parentElement.querySelector("[data-sae-stock-label]");
      var buy = form.querySelector("[data-sae-buy-now]");
      var stock = form.parentElement.querySelector(".w-commerce-commerceaddtocartoutofstock");
      form.dataset.saeStockBound = "true";
      function sync() {
        var field = form.querySelector('[name="id"]');
        var variant = field && variants.find(function (v) { return String(v.id) === field.value; });
        if (!variant) return;
        if (buy) buy.hidden = !variant.available;
        if (stock) stock.style.display = variant.available ? "none" : "block";
        if (label) {
          label.textContent = variant.available ? (label.dataset.comingSoon === "true" ? label.dataset.comingLabel : "") : label.dataset.soldOutLabel;
          label.hidden = !label.textContent;
        }
      }
      form.addEventListener("change", function () { requestAnimationFrame(sync); });
      document.addEventListener("DOMContentLoaded", sync, { once: true });
      sync(); requestAnimationFrame(sync);
    });
  }
  window.SAEProductLayout = { initialize: initialize };
  initialize(); document.addEventListener("shopify:section:load", initialize);
})();
